<template>
  <div>
    <b-row>
      <b-col
        lg="2"
        md="12"
        style="border-right: solid 1px #80808038"
      >
        <b-button
          variant="outline-primary"
          size="sm"
          class="ml-auto"
          :disabled="computing"
          @click="add()"
        >
          ADD PIPELINE
        </b-button><br><br><br>
        <b-button
          variant="outline-danger"
          size="sm"
          :disabled="computing"
          style="width: 83%;   position: absolute;  bottom: 0;"
          class="ml-auto"
          @click="clear()"
        >
          CLEAR
        </b-button>
      </b-col>
      <b-col
        lg="10"
        md="12"
      >
        <flowchart
          ref="chart"
          style="width:100%; height: 400px!important; border: unset"
          :width="'100%'"
          :disabled="computing"
          :height="400"
          :nodes="nodes"
          :connections="connections"
        />
      </b-col>
    </b-row>
  </div>
</template>
<script>
import Vue from 'vue'
import FlowChart from 'bloques'
import {
  BRow, BCol,
  BButton,
} from 'bootstrap-vue'

import store from '@/store/index'
import axios from 'axios'

const { url, port, auth } = store.state.appConfig.api
const headers = {
  authentication: auth,
  'Content-Type': 'application/json',
}
Vue.use(FlowChart)

export default {
  components: {
    BRow,
    BCol,
    BButton,
  },
  props: {
    selected: {
      required: true,
      type: Boolean,
    },
    computing: {
      required: true,
      type: Boolean,
    },
  },
  data() {
    return {
      nodes: [],
      connections: [],
    }
  },
  watch: {
    selected() {
      if (this.selected === true) {
        this.add(false)
      } else {
        this.clear(false)
      }
    },
  },
  mounted() {
    if (this.selected) {
      this.add(false)
    }
  },
  methods: {
    add(save = true) {
      this.nodes = [{
        id: 1,
        x: 10,
        y: 90,
        height: 90,
        width: 100,
        inputs: 0,
        name: 'CZI EXTRACTION',
        type: 'operation',
        class: 'test',
        approvers: [{ id: 1, name: '1' }],
      }, {
        id: 2,
        x: 120,
        y: 90,
        height: 90,
        width: 100,
        inputs: 1,
        name: 'Flat Field Correction',
        type: 'operation',
        class: 'test',
        approvers: [{ id: 1, name: '2' }],
      }, {
        id: 3,
        x: 230,
        y: 90,
        height: 90,
        width: 100,
        inputs: 1,
        name: 'Stitching',
        type: 'operation',
        class: 'test',
        approvers: [{ id: 1, name: '3' }],
      },
      {
        id: 4,
        x: 340,
        y: 90,
        height: 90,
        width: 100,
        inputs: 1,
        name: 'Registration',
        type: 'operation',
        class: 'test',
        approvers: [{ id: 1, name: '4' }],
      },
      {
        id: 5,
        x: 450,
        y: 90,
        height: 90,
        width: 100,
        inputs: 1,
        name: 'Segmentation',
        type: 'operation',
        class: 'test',
        approvers: [{ id: 1, name: '5' }],
      },
      {
        id: 6,
        x: 560,
        y: 90,
        height: 90,
        width: 100,
        inputs: 1,
        name: 'Autofluorescence Subtraction',
        type: 'operation',
        class: 'test',
        approvers: [{ id: 1, name: '6' }],
      },
      {
        id: 7,
        x: 670,
        y: 90,
        height: 90,
        width: 100,
        inputs: 1,
        name: 'Feature Extraction',
        type: 'operation',
        class: 'test',
        approvers: [{ id: 1, name: '7' }],
      }]
      this.connections = [
        {
          source: { id: 1, position: 'output' },
          destination: { id: 2, position: 'input1' },
          id: 1,
          type: 'pass',
        },
        {
          source: { id: 2, position: 'output' },
          destination: { id: 3, position: 'input1' },
          id: 1,
          type: 'pass',
        },
        {
          source: { id: 3, position: 'output' },
          destination: { id: 4, position: 'input1' },
          id: 1,
          type: 'pass',
        },
        {
          source: { id: 4, position: 'output' },
          destination: { id: 5, position: 'input1' },
          id: 1,
          type: 'pass',
        },
        {
          source: { id: 5, position: 'output' },
          destination: { id: 6, position: 'input1' },
          id: 1,
          type: 'pass',
        },
        {
          source: { id: 6, position: 'output' },
          destination: { id: 7, position: 'input1' },
          id: 1,
          type: 'pass',
        },
      ]
      if (save === true) {
        this.update()
      }
    },
    clear(save = true) {
      this.nodes = []
      if (save === true) {
        this.update()
      }
    },
    update() {
      const { id } = this.$route.params
      const defaultPipeline = [
        { block: '1', content: ['1.1', '1.2', '1.3'] },
        {
          block: '2',
          content: ['2.1.1', '2.1.2', '2.1.3'],
        },
        { block: '3', content: ['3.0', '3.1', '3.2', '3.4', '3.5'] },
        { block: '4', content: ['4.1', '4.2', '4.3', '4.4'] },
        { block: '5', content: ['5.1', '5.2'] },
        { block: '6', content: ['6.1'] },
        { block: '7', content: ['7.1'] },
      ]
      const pipeline = (this.nodes.length === 0) ? {} : defaultPipeline
      const data = JSON.stringify({ pipeline })
      axios.put(`${url}:${port}/add-pipeline/${id}`, data, { headers })
    },
  },
}
</script>
